import React from 'react';
import Layout from '../../components/layout/Layout';
import PeriodoEscolar from '../../components/academico/PeriodoEscolar';

const PeriodoEscolarPage = () => {
    return ( <Layout children={<PeriodoEscolar />} /> )
}

export default PeriodoEscolarPage;